import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DatePicker as PrimeDatePicker } from 'primeng/datepicker';

import { type DynamicAction } from '@shared/registry/dynamic';

import { type DatePickerConfig } from './date-picker.types';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.html',
  imports: [FormsModule, PrimeDatePicker],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatePicker {
  readonly config = input<DatePickerConfig>();

  readonly action = output<DynamicAction>();

  protected readonly ngModelValue = signal<Date | null>(null);

  constructor() {
    effect(() => {
      const selected = this.config()?.selectedDate;
      if (selected) {
        this.ngModelValue.set(selected);
      }
    });
  }

  protected onSelect(date: Date): void {
    this.ngModelValue.set(date);
    this.action.emit({ id: 'dateSelected', data: date });
  }

  protected onMonthNavigate(event: { month?: number; year?: number }): void {
    if (event.month === undefined || event.year === undefined) return;
    this.action.emit({ id: 'monthChanged', data: { month: event.month, year: event.year } });
  }
}
